import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../../constants/common'
import Button, { BUTTON_HEIGHT_32 } from '../../../../Button'
import { ICON_HEIGHT_16, IconWithTooltip } from '../../../../Icon'
import { ListItemIcons } from '../../../../ListItem'

import DeleteIcon from '../../../../../icons/delete.svg'
import LockIcon from '../../../../../icons/lock.svg'

function ViewingApplicantsItemIcons({
  canDelete,
  deleteButtonQaName,
  isDeleting,
  isDisabled,
  isHovered,
  lockedTooltip,
  onDelete,
  ...restProps
}) {
  const { t } = useTranslation()

  return (
    <ListItemIcons {...restProps}>
      {canDelete && (isHovered || isDeleting) ? (
        <Button.Outlined
          isGrey
          beforeIconProps={{ Icon: DeleteIcon }}
          disabled={isDisabled}
          height={BUTTON_HEIGHT_32}
          isLoading={isDeleting}
          qaName={deleteButtonQaName}
          tooltip={t('Modal.DeleteBtnKey')}
          tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
          onClick={onDelete}
        />
      ) : lockedTooltip && isHovered ? (
        <IconWithTooltip
          Icon={LockIcon}
          size={ICON_HEIGHT_16}
          tooltip={lockedTooltip}
          tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
        />
      ) : null}
    </ListItemIcons>
  )
}

export default ViewingApplicantsItemIcons
